import { Log } from '@core';
import { filter, first, Observable, of, switchMap, tap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { LoadFeatureFlagsCommandHandler } from '@feature-flags';

export class LoadFeatureFlagsStep extends StartupStep {
  private readonly loadFeatureFlagsCommandHandler: LoadFeatureFlagsCommandHandler =
    inject(LoadFeatureFlagsCommandHandler);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'LoadFeatureFlagsStep START' });
    state.authed$
      ?.pipe(
        filter(Boolean),
        first(),
        switchMap(() => this.loadFeatureFlagsCommandHandler.loadFlags()),
        tap(() => (state.featureFlagsLoaded$ = of(true))),
        tap(() => this.logger.log(Log.Startup, { message: 'LoadFeatureFlagsStep COMPLETED' }))
      )
      .subscribe();

    return of(state);
  }
}
